<template>
    <span>
        <pazar-plus-modules></pazar-plus-modules>
        <page-footer></page-footer>
    </span>
</template>
<script>
import PazarPlusModules from '@/components/PazarPlusModules';
import PageFooter from '@/components/PageFooter';
export default {
    name: 'modulesplus',
    components: {
        PazarPlusModules,
        PageFooter
    }
};
</script>


